
import moment from 'moment';

class StringUtils {

    /**
     * 获取嵌套值
     * @param obj 对象
     * @param path 路径
     */
    static getNestedValue = (obj: any, path: string) => {
        let value = obj;
        path.split('.').forEach((key: string) => {
            if (value && Object.prototype.hasOwnProperty.call(value, key)) {
                // 如果是数字且小数部分超过2位，则保留两位小数
                value = typeof value[key] === 'number' && value[key].toString().split('.')[1]?.length > 2 ? value[key].toFixed(2) : value[key];

            } else {
                value = '不明';
            }
        });
        return value;
    };

    /**
     * 获取格式化时间
     * @param time 时间
     */
    static getFormatTime(time: string) {
        return moment(time).format('YYYY-MM-DD HH:mm:ss');
    }

    /**
     * 获取标记
     * @param value 布尔值
     */
    static getFlag(value: boolean) {
        return value ? '◯' : '×';
    }
}

export default StringUtils;